// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { fermentationId } from './Fermentation';
import { downstreamOperationId } from './DownstreamOperation';
import { fractionEnum40150981 } from './FractionEnum40150981';
import { z } from 'zod';
export const sampleId = (z.number());
export const sample = z.object({
    id: sampleId,
    responsible_operator_id: operatorId.nullable(),
    fermentation_id: fermentationId.nullable(),
    freshness_of_sample_days: z.number().nullable(),
    description: z.string().nullable(),
    total_weight_g: z.string().nullable(),
    locked: z.boolean().nullable(),
    dsp_1_id: downstreamOperationId.nullable(),
    dsp_2_id: downstreamOperationId.nullable(),
    dsp_3_id: downstreamOperationId.nullable(),
    dsp_4_id: downstreamOperationId.nullable(),
    parent_sample_id: sampleId.nullable(),
    fraction: fractionEnum40150981,
    name: z.string().nullable(),
    dry_matter_pct: z.string().nullable(),
});
export const sampleInitializer = z.object({
    id: sampleId.optional(),
    responsible_operator_id: operatorId.optional().nullable(),
    fermentation_id: fermentationId.optional().nullable(),
    freshness_of_sample_days: z.number().optional().nullable(),
    description: z.string().optional().nullable(),
    total_weight_g: z.string().optional().nullable(),
    locked: z.boolean().optional().nullable(),
    dsp_1_id: downstreamOperationId.optional().nullable(),
    dsp_2_id: downstreamOperationId.optional().nullable(),
    dsp_3_id: downstreamOperationId.optional().nullable(),
    dsp_4_id: downstreamOperationId.optional().nullable(),
    parent_sample_id: sampleId.optional().nullable(),
    fraction: fractionEnum40150981,
    name: z.string().optional().nullable(),
    dry_matter_pct: z.string().optional().nullable(),
});
export const sampleMutator = z.object({
    id: sampleId.optional(),
    responsible_operator_id: operatorId.optional().nullable(),
    fermentation_id: fermentationId.optional().nullable(),
    freshness_of_sample_days: z.number().optional().nullable(),
    description: z.string().optional().nullable(),
    total_weight_g: z.string().optional().nullable(),
    locked: z.boolean().optional().nullable(),
    dsp_1_id: downstreamOperationId.optional().nullable(),
    dsp_2_id: downstreamOperationId.optional().nullable(),
    dsp_3_id: downstreamOperationId.optional().nullable(),
    dsp_4_id: downstreamOperationId.optional().nullable(),
    parent_sample_id: sampleId.optional().nullable(),
    fraction: fractionEnum40150981.optional(),
    name: z.string().optional().nullable(),
    dry_matter_pct: z.string().optional().nullable(),
});
//# sourceMappingURL=Sample.js.map